export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'

export const DEVICE_AUTH_REQUEST = 'DEVICE_ASSOC_REQUEST'
export const DEVICE_AUTH_SUCCESS = 'DEVICE_ASSOC_SUCCESS'
export const DEVICE_AUTH_FAILURE = 'DEVICE_ASSOC_FAILURE'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.ts